import type { LocaleMessageBundle } from '../../types'
import { deliveryPartnerMessages } from './delivery-partner'
import { inventoryMessages as baseInventoryMessages } from './inventory'
import { transferOrderMessages } from './transfer-order'

export const inventoryMessages: LocaleMessageBundle = {
  vi: {
    ...baseInventoryMessages.vi,
    ...deliveryPartnerMessages.vi,
    ...transferOrderMessages.vi,
  },
  en: {
    ...baseInventoryMessages.en,
    ...deliveryPartnerMessages.en,
    ...transferOrderMessages.en,
  },
}
